module.exports = __webpack_public_path__ + "static/media/serviceIndustry4.ba1638fb.png";